module.exports = __webpack_public_path__ + "static/media/James Bradley.5a7aa87b.png";